module.exports = __webpack_public_path__ + "static/media/dsr_journey2.e8d501ed.svg";